/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, verb: NonNullable<unknown> }} Home_Pulse_Detail_Fieldschanged1Inputs */

const id_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} bidang ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} bidang ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const ms_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} medan ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} medan ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const da_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} felt ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} felter ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const de_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} Feld ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} Felder ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const en_us2_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} field ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} fields ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const es_es2_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} campo ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} campos ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const es_mx2_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} campo ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} campos ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const fil_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} field ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} field ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const fr_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} champ ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} champs ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const it_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} campo ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} campi ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const hu_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} mező ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} mező ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const nl_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} veld ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} velden ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const no_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} felt ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} felt ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const pl_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} pole ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} pól ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const pt_br2_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} campo ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} campos ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const pt_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} campo ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} campos ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const ro_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} câmp ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} câmpuri ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const fi_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} kenttä ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} kenttää ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const sv_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} fält ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} fält ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const vi_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} trường ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} trường ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const tr_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} alan ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} alan ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const cs_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} pole ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} polí ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const bg_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} поле ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} полета ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const ru_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} поле ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} полей ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const uk_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} поле ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} полів ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const ar_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} حقل ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} حقول ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const hi_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} फ़ील्ड ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} फ़ील्ड ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const th_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} ฟิลด์ ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} ฟิลด์ ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const ja_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} フィールドが${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} フィールドが${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const zh_cn2_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 个字段 ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 个字段 ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const zh_hant1_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} 個欄位 ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} 個欄位 ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

const ko_home_pulse_detail_fieldschanged1 = /** @type {(inputs: Home_Pulse_Detail_Fieldschanged1Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`필드 ${i?.count}개 ${i?.verb}`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`필드 ${i?.count}개 ${i?.verb}`);
	return /** @type {LocalizedString} */ ("home.pulse.detail.fieldsChanged");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} field {verb}" |
* | "other" | "{count} fields {verb}" |
*
* @param {Home_Pulse_Detail_Fieldschanged1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_pulse_detail_fieldschanged1 = /** @type {((inputs: Home_Pulse_Detail_Fieldschanged1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Pulse_Detail_Fieldschanged1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "ms") return ms_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "da") return da_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "de") return de_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "en-US") return en_us2_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "es-ES") return es_es2_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "es-MX") return es_mx2_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "fil") return fil_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "fr") return fr_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "it") return it_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "hu") return hu_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "nl") return nl_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "no") return no_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "pl") return pl_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "pt-BR") return pt_br2_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "pt") return pt_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "ro") return ro_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "fi") return fi_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "sv") return sv_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "vi") return vi_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "tr") return tr_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "cs") return cs_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "bg") return bg_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "ru") return ru_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "uk") return uk_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "ar") return ar_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "hi") return hi_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "th") return th_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "ja") return ja_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "zh-CN") return zh_cn2_home_pulse_detail_fieldschanged1(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_pulse_detail_fieldschanged1(inputs)
	return ko_home_pulse_detail_fieldschanged1(inputs)
});
export { home_pulse_detail_fieldschanged1 as "home.pulse.detail.fieldsChanged" }